var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22192",
    "data-name": "\\uADF8\\uB8F9 22192",
    transform: "translate(8842 -5398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1577",
    "data-name": "\\uD0C0\\uC6D0 1577",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-8842 5398)",
    fill: "#035700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10377",
    "data-name": "\\uD328\\uC2A4 10377",
    d: "M-.412.291H-1.94V2.879H-3.434v-7.2H-.3a2.553,2.553,0,0,1,1.729.557,2.157,2.157,0,0,1,.645,1.724,2.209,2.209,0,0,1-.645,1.8A2.838,2.838,0,0,1-.412.291Zm.7-1.5a1.041,1.041,0,0,0,.293-.82.974.974,0,0,0-.3-.8,1.282,1.282,0,0,0-.828-.239h-1.4V-.949h1.4A1.225,1.225,0,0,0,.291-1.208ZM5.958.291H4.43V2.879H2.936v-7.2H6.071A2.553,2.553,0,0,1,7.8-3.762a2.157,2.157,0,0,1,.645,1.724A2.209,2.209,0,0,1,7.8-.236,2.838,2.838,0,0,1,5.958.291Zm.7-1.5a1.041,1.041,0,0,0,.293-.82.974.974,0,0,0-.3-.8,1.282,1.282,0,0,0-.828-.239H4.43V-.949h1.4A1.225,1.225,0,0,0,6.662-1.208Z",
    transform: "translate(-8834.064 5408.985)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection06);
export default __webpack_public_path__ + "static/media/inspection_06.e9c83e4ff9d82d13d17246e2e72e540a.svg";
export { ForwardRef as ReactComponent };